<button
  type="button"
  class="tp-support-launcher"
  id="supportLauncher"
  [attr.aria-label]="supportUnreadCount ? 'Open support, ' + supportUnreadCount + ' unread messages' : 'Open support'"
  [class.tp-support-launcher--hidden]="isSupportShellOpen"
  [class.tp-support-launcher--has-unread]="supportUnreadCount > 0"
  [class.tp-support-launcher--with-attendance]="hasAttendanceDock"
  [class.tp-support-launcher--attendance-route]="isAttendanceRoute"
  [class.tp-support-launcher--discussion]="isDiscussionRoute"
  [class.tp-support-launcher--report-drawer]="isReportCustomizeDrawerOpen"
  (click)="toggleSupportShell($event)"
>
  <span class="tp-support-launcher-badge" *ngIf="supportUnreadCount > 0">
    {{ supportUnreadCount > 99 ? "99+" : supportUnreadCount }}
  </span>
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M4 13v-2a8 8 0 0 1 16 0v2"></path>
    <path d="M4 13h3v6H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 1-2zM20 13h-3v6h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-1-2z"></path>
    <path d="M17 19c0 1.1-1.8 2-4 2"></path>
  </svg>
</button>

<section
  class="tp-support-shell"
  id="supportShell"
  aria-label="TaskOPad support panel"
  [class.tp-support-shell--open]="isSupportShellOpen"
  [class.tp-support-shell--with-attendance]="hasAttendanceDock"
  [class.tp-support-shell--attendance-route]="isAttendanceRoute"
  [class.tp-support-shell--report-drawer]="isReportCustomizeDrawerOpen"
  (click)="preventSupportShellClose($event)"
>
  <header class="tp-support-head">
    <button
      *ngIf="currentSupportScreen === 'chat'"
      type="button"
      class="tp-support-head-back-btn"
      aria-label="Back to support home"
      (click)="openSupportScreen('home', $event)"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M15 18l-6-6 6-6"></path>
      </svg>
    </button>
    <div class="tp-support-brand-avatar-wrap">
      <div class="tp-support-brand-avatar">T</div>
      <span class="tp-support-brand-status"></span>
    </div>
    <div class="tp-support-head-copy">
      <h3>TaskOPad Support</h3>
      <!-- <span class="tp-support-online">Support team online</span> · -->
      <p> Usually replies in Few minutes</p>
    </div>
    <div class="tp-support-head-actions">
      <!-- <button
        type="button"
        class="tp-support-icon-btn tp-support-icon-btn--glass"
        aria-label="Collapse"
        (click)="toggleSupportShell($event)"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M7 10l5 5 5-5"></path>
        </svg>
      </button> -->
      <button
        type="button"
        class="tp-support-icon-btn tp-support-icon-btn--glass"
        aria-label="Minimize"
        (click)="closeSupportShell()"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M7 12h10"></path>
        </svg>
      </button>
      <!-- <button
        type="button"
        class="tp-support-icon-btn tp-support-icon-btn--glass"
        aria-label="Close"
        (click)="closeSupportShell()"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M8 8l8 8M16 8l-8 8"></path>
        </svg>
      </button> -->
    </div>
  </header>

  <div class="tp-support-body">
    <div
      class="tp-support-screen"
      [class.tp-support-screen--active]="currentSupportScreen === 'home'"
      data-screen="home"
    >
      <div class="tp-support-hello-card">
        <h2>Hello {{ supportGreetingName }} 👋</h2>
        <p>Need help with TaskOPad? Start a live chat or request a callback from our support team.</p>
      </div>

      <div class="tp-support-contact-card">
        <div class="tp-support-contact-title">Contact us</div>

        <button
          type="button"
          class="tp-support-contact-option"
          (click)="openSupportScreen('chatForm', $event)"
        >
          <span class="tp-support-option-icon tp-support-option-icon--chat">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M4 5h16v12H9l-5 4z"></path>
            </svg>
          </span>
          <span class="tp-support-option-copy">
            <b>Start live chat</b>
            <span>Available from 10:00 AM to 7:00 PM(IST)</span>
          </span>
          <span class="tp-support-chevron">›</span>
        </button>

        <button
          type="button"
          class="tp-support-contact-option"
          (click)="openSupportScreen('callback', $event)"
        >
          <span class="tp-support-option-icon tp-support-option-icon--call">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M6 3h4l2 5-3 2a15 15 0 0 0 5 5l2-3 5 2v4c0 2-2 3-4 3C9 20 4 15 3 7c0-2 1-4 3-4z"></path>
            </svg>
          </span>
          <span class="tp-support-option-copy">
            <b>Request a callback</b>
            <span>Our executive will call you soon</span>
          </span>
          <span class="tp-support-chevron">›</span>
        </button>
      </div>

      <div class="tp-support-info-strip">
        Support hours: Monday to Saturday, 10:00 AM–7:00 PM(IST). Requests received outside working hours are handled on the next business day.
      </div>
      <div class="tp-support-powered">Powered by TaskOPad Support</div>
    </div>

    <div
      class="tp-support-screen"
      [class.tp-support-screen--active]="currentSupportScreen === 'chatForm'"
      data-screen="chatForm"
    >
      <div class="tp-support-back-row">
        <button
          type="button"
          class="tp-support-back-btn"
          aria-label="Back"
          (click)="openSupportScreen('home', $event)"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M15 18l-6-6 6-6"></path>
          </svg>
        </button>
        <div class="tp-support-screen-heading">
          <h3>Start live chat</h3>
          <p>Tell us briefly what you need help with.</p>
        </div>
      </div>

      <form class="tp-support-form-card">
        <div
          class="tp-support-field tp-support-field--select"
          [class.tp-support-field--active]="supportSelectFocus.chatCategory || !!selectedSupportCategory"
        >
          <select
            [(ngModel)]="selectedSupportCategory"
            name="supportCategory"
            (focus)="setSupportSelectFocus('chatCategory', true)"
            (blur)="setSupportSelectFocus('chatCategory', false)"
          >
            <option value="" disabled hidden></option>
            <option *ngFor="let option of supportCategoryOptions" [value]="option">
              {{ option }}
            </option>
          </select>
          <label>Select category</label>
        </div>

        <div class="tp-support-field">
          <textarea
            [(ngModel)]="supportChatMessage"
            (ngModelChange)="onSupportChatMessageChange($event)"
            name="supportChatMessage"
            maxlength="800"
            placeholder=" "
          ></textarea>
          <label>Message</label>
        </div>

        <button
          type="button"
          class="tp-support-primary"
          [disabled]="
            isSubmittingSupportChat ||
            !selectedSupportCategory ||
            supportChatMessage.trim().length < 10
          "
          (click)="startSupportChat(supportChatMessage, $event)"
        >
          {{ isSubmittingSupportChat ? "Starting..." : "Start Chat" }}
        </button>
      </form>
    </div>

    <div
      class="tp-support-screen"
      [class.tp-support-screen--active]="currentSupportScreen === 'callback'"
      data-screen="callback"
    >
      <div class="tp-support-back-row">
        <button
          type="button"
          class="tp-support-back-btn"
          aria-label="Back"
          (click)="openSupportScreen('home', $event)"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M15 18l-6-6 6-6"></path>
          </svg>
        </button>
        <div class="tp-support-screen-heading">
          <h3>Request a callback</h3>
          <p>Choose a convenient time for our team to call you.</p>
        </div>
      </div>

      <form class="tp-support-form-card">
        <div class="tp-support-field">
          <input [(ngModel)]="callbackName" name="callbackName" placeholder=" " />
          <label>Name</label>
        </div>

        <div class="tp-support-mobile-row">
          <div class="tp-support-field tp-support-field--code">
            <input
              [(ngModel)]="callbackIsdCode"
              (ngModelChange)="onCallbackIsdCodeChange($event)"
              name="callbackIsdCode"
              type="tel"
              inputmode="numeric"
              maxlength="5"
              placeholder=" "
            />
            <label>Code</label>
          </div>

          <div class="tp-support-field tp-support-field--mobile">
            <input
              [(ngModel)]="callbackMobileNumber"
              (ngModelChange)="onCallbackMobileNumberChange($event)"
              name="callbackMobileNumber"
              type="tel"
              inputmode="numeric"
              maxlength="15"
              placeholder=" "
            />
            <label>Mobile number</label>
            <div
              class="tp-support-field-error"
              *ngIf="getCallbackMobileNumberValidationMessage()"
            >
              {{ getCallbackMobileNumberValidationMessage() }}
            </div>
          </div>
        </div>

        <div
          class="tp-support-field tp-support-field--select"
          [class.tp-support-field--active]="supportSelectFocus.callbackReason || !!selectedCallbackReason"
        >
          <select
            [(ngModel)]="selectedCallbackReason"
            name="callbackReason"
            (focus)="setSupportSelectFocus('callbackReason', true)"
            (blur)="setSupportSelectFocus('callbackReason', false)"
          >
            <option value="" disabled hidden></option>
            <option *ngFor="let option of supportCategoryOptions" [value]="option">
              {{ option }}
            </option>
          </select>
          <label>Reason for callback</label>
        </div>

        <div class="tp-support-field">
          <textarea
            [(ngModel)]="callbackMessage"
            (ngModelChange)="onCallbackMessageChange($event)"
            name="callbackMessage"
            maxlength="800"
            placeholder=" "
          ></textarea>
          <label>Message</label>
        </div>

        <button
          type="button"
          class="tp-support-primary"
          [disabled]="
            isSubmittingCallbackRequest ||
            !callbackName.trim() ||
            !isCallbackMobileNumberValid() ||
            !selectedCallbackReason ||
            callbackMessage.trim().length < 10
          "
          (click)="submitCallbackRequest($event)"
        >
          {{
            isSubmittingCallbackRequest
              ? "Submitting..."
              : "Submit Callback Request"
          }}
        </button>
      </form>
    </div>

    <div
      class="tp-support-screen"
      [class.tp-support-screen--active]="currentSupportScreen === 'chat'"
      data-screen="chat"
    >
      <div class="tp-support-chat-layout">
        <div
          class="tp-support-messages"
          id="tpSupportMessages"
          (scroll)="onSupportMessagesScroll($event)"
        >
          <div class="tp-support-time-label">Conversation started just now</div>
          <div
            class="tp-support-history-loader"
            *ngIf="supportLoadingOlderIssueHistory"
          >
            Loading older history...
          </div>
          <ng-container *ngFor="let message of chatMessages">
            <div
              *ngIf="message.kind === 'divider'"
              class="tp-support-issue-divider"
            >
              <b>{{ message.label }}</b>
              <span *ngIf="message.sublabel">{{ message.sublabel }}</span>
            </div>
            <div
              *ngIf="message.kind === 'date-divider'"
              class="tp-support-time-label"
            >
              {{ message.label }}
            </div>
            <div
              *ngIf="message.kind === 'system-divider'"
              class="tp-support-time-label tp-support-time-label--system"
            >
              {{ message.label }}
            </div>
            <ng-container *ngIf="message.kind === 'message'">
              <div
                class="tp-support-bubble-row"
                [class.tp-support-bubble-row--me]="message.kind === 'message' && message.who === 'me'"
              >
                <div
                  class="tp-support-bubble"
                  (contextmenu)="openSupportMessageMenu(message, $any($event))"
                  [class.tp-support-bubble--user]="message.kind === 'message' && message.who === 'me'"
                  [class.tp-support-bubble--agent]="message.kind === 'message' && message.who === 'agent'"
                  [class.tp-support-bubble--image-only]="message.kind === 'message' && hasOnlyImageAttachments(message)"
                  [class.tp-support-bubble--video-only]="message.kind === 'message' && hasOnlyVideoAttachments(message)"
                  [class.tp-support-bubble--file-only]="message.kind === 'message' && hasOnlyFileAttachments(message)"
                >
                  <div
                    class="tp-support-reply-preview tp-support-reply-preview--bubble"
                    *ngIf="hasSupportParentMessage(message)"
                  >
                    <div class="tp-support-reply-preview__copy">
                      <b>{{ getSupportParentSenderName(message) }}</b>
                      <span>{{ getSupportParentPreviewText(message) }}</span>
                    </div>
                  </div>
                  <div
                    class="tp-support-attachment-list"
                    *ngIf="message.kind === 'message' && message.attachments?.length"
                  >
                    <ng-container *ngFor="let attachment of message.attachments">
                      <button
                        *ngIf="isSupportImageAttachment(attachment); else supportNonImageAttachment"
                        type="button"
                        class="tp-support-attachment-image-link"
                        (click)="openSupportImagePreview(attachment, $event)"
                      >
                        <img
                          class="tp-support-attachment-image"
                          [src]="getSupportAttachmentPreviewSrc(attachment)"
                          [alt]="attachment?.attachement_name || 'attachment'"
                          (load)="onSupportAttachmentImageLoad()"
                          (error)="onSupportAttachmentImageError($event, attachment)"
                        />
                      </button>
                      <ng-template #supportNonImageAttachment>
                        <button
                          *ngIf="isSupportVideoAttachment(attachment); else supportFileAttachment"
                          type="button"
                          class="tp-support-attachment-image-link tp-support-attachment-image-link--video"
                          (click)="openSupportImagePreview(attachment, $event)"
                        >
                          <img
                            class="tp-support-attachment-image tp-support-attachment-video"
                            [src]="getSupportAttachmentPreviewSrc(attachment)"
                            [alt]="attachment?.attachement_name || 'attachment'"
                            (load)="onSupportAttachmentImageLoad()"
                            (error)="onSupportAttachmentImageError($event, attachment)"
                          />
                          <span class="tp-support-attachment-play" aria-hidden="true">
                            <svg viewBox="0 0 24 24" focusable="false">
                              <path d="M8 6v12l10-6z"></path>
                            </svg>
                          </span>
                        </button>
                        <ng-template #supportFileAttachment>
                          <button
                            type="button"
                            class="tp-support-attachment-file"
                            (click)="downloadSupportAttachment(attachment, $event)"
                          >
                            <span class="tp-support-attachment-file__icon">
                              {{ getSupportAttachmentExtension(attachment) }}
                            </span>
                            <span class="tp-support-attachment-file__name">
                              {{ attachment?.attachement_name || attachment?.name || "Attachment" }}
                            </span>
                          </button>
                        </ng-template>
                      </ng-template>
                    </ng-container>
                  </div>
                  <span *ngIf="message.kind === 'message' && message.text">{{ message.text }}</span>
                  <small *ngIf="message.kind === 'message'">{{ message.time }}</small>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>

        <div class="tp-support-typing" [class.tp-support-typing--show]="showSupportTyping">
          {{ supportTypingLabel || "Support is typing..." }}
        </div>

        <div class="tp-support-composer">
          <div
            class="tp-support-emoji-panel"
            *ngIf="showSupportEmojiPicker"
          >
            <button
              *ngFor="let emoji of supportEmojiOptions"
              type="button"
              class="tp-support-emoji-option"
              (click)="addSupportEmoji(emoji, $event)"
            >
              {{ emoji }}
            </button>
          </div>
          <div
            class="tp-support-pending-attachments"
            *ngIf="pendingSupportAttachments.length"
          >
            <div
              class="tp-support-pending-attachment"
              *ngFor="let attachment of pendingSupportAttachments; let i = index"
              [title]="attachment.name"
            >
              <div
                *ngIf="isPendingSupportVideoAttachment(attachment); else supportPendingImageOrFile"
                class="tp-support-pending-video"
              >
                <span>VIDEO</span>
              </div>
              <ng-template #supportPendingImageOrFile>
              <img
                class="tp-support-pending-image"
                [src]="getPendingSupportPreviewSrc(attachment)"
                [alt]="attachment.name"
                (error)="onPendingSupportImageError(i)"
              />
              </ng-template>
              <button
                type="button"
                class="tp-support-remove-attachment"
                (click)="removePendingSupportAttachment(i, $event)"
              >
                ×
              </button>
            </div>
          </div>
          <div class="tp-support-composer-main">
            <div class="tp-support-composer-field">
              <div
                class="tp-support-reply-preview"
                *ngIf="supportReplyTarget"
              >
                <div class="tp-support-reply-preview__copy">
                  <b>{{ getSupportReplySenderName(supportReplyTarget) }}</b>
                  <span>{{ getSupportReplyPreviewText(supportReplyTarget) }}</span>
                </div>
                <button
                  type="button"
                  class="tp-support-reply-preview__close"
                  (click)="cancelSupportReply()"
                  aria-label="Cancel reply"
                >
                  ×
                </button>
              </div>
              <div class="tp-support-composer-input-wrap">
                <textarea
                  id="tpSupportReplyComposer"
                  [(ngModel)]="supportReplyMessage"
                  (ngModelChange)="onSupportReplyChange($event)"
                  (paste)="onSupportComposerPaste($any($event))"
                  (keydown.enter)="onSupportComposerEnter($any($event))"
                  name="supportReplyMessage"
                  maxlength="800"
                  placeholder=" "
                  autocomplete="off"
                  rows="1"
                ></textarea>
                <label>Write a message...</label>
              </div>
            </div>
          <input
            #supportAttachmentInput
            type="file"
            hidden
            multiple
            accept=".jpg,.jpeg,.png,.gif,.webp,.svg,.bmp,.heic,.pdf,.doc,.docx,.xls,.xlsx,.txt,.csv,.mp4,.mov,.avi,.mkv,.webm,.m4v,image/*,video/mp4,video/quicktime,video/x-msvideo,video/x-matroska,video/webm,video/x-m4v,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/plain,text/csv"
            (change)="onSupportAttachmentSelected($any($event.target).files); supportAttachmentInput.value = ''"
          />
          <button
            type="button"
            class="tp-support-action-btn"
            (click)="supportAttachmentInput.click()"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M21 11.5l-8.5 8.5a5 5 0 0 1-7.1-7.1l9.2-9.2a3.5 3.5 0 1 1 5 5l-9.2 9.2a2 2 0 1 1-2.8-2.8l8.5-8.5"></path>
            </svg>
          </button>
          <button
            type="button"
            class="tp-support-action-btn"
            (click)="toggleSupportEmojiPicker($event)"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <circle cx="12" cy="12" r="9"></circle>
              <path d="M8.5 10h.01M15.5 10h.01"></path>
              <path d="M8 14c1 1.3 2.4 2 4 2s3-.7 4-2"></path>
            </svg>
          </button>
          <button
            type="button"
            class="tp-support-send"
            [disabled]="
              isSendingSupportMessage ||
              (!supportReplyMessage.trim() && !pendingSupportAttachments.length)
            "
            (click)="sendSupportMessage($event)"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M4 12l16-8-5 16-3-6z"></path>
              <path d="M12 14l8-10"></path>
            </svg>
          </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="tp-support-screen"
      [class.tp-support-screen--active]="currentSupportScreen === 'success'"
      data-screen="success"
    >
      <div class="tp-support-success">
        <div class="tp-support-success-card">
          <div class="tp-support-success-icon">
            <span>✓</span>
          </div>
          <div class="tp-support-success-copy">
            <span class="tp-support-success-kicker">Callback booked</span>
            <h3>Callback request submitted</h3>
            <p>Our support executive will call you soon regarding your selected issue.</p>
          </div>
          <div class="tp-support-success-note">
            Support hours: Monday to Saturday, 10:00 AM to 7:00 PM.
          </div>
          <button
            type="button"
            class="tp-support-primary tp-support-success-action"
            (click)="openSupportScreen('home', $event)"
          >
            Back to Support Home
          </button>
        </div>
      </div>
    </div>
  </div>

</section>

<div
  class="tp-support-message-menu"
  *ngIf="supportMessageMenu.open && supportMessageMenu.message"
  [style.left.px]="supportMessageMenu.x"
  [style.top.px]="supportMessageMenu.y"
  (click)="$event.stopPropagation()"
>
  <button
    type="button"
    class="tp-support-message-menu__item"
    (click)="replyToSupportMessage(supportMessageMenu.message, $event)"
  >
    <span>↩</span>
    Reply
  </button>
  <button
    type="button"
    class="tp-support-message-menu__item"
    *ngIf="canCopySupportMessage(supportMessageMenu.message)"
    (click)="copySupportMessage(supportMessageMenu.message, $event)"
  >
    <span>⧉</span>
    Copy
  </button>
</div>

<div
  class="tp-support-image-preview"
  *ngIf="isSupportImagePreviewOpen"
  (click)="closeSupportImagePreview($event)"
>
  <div
    class="tp-support-image-preview__dialog"
    (click)="preventSupportShellClose($event)"
  >
    <div class="tp-support-image-preview__head">
      <span>{{ supportImagePreviewName }}</span>
      <div class="tp-support-image-preview__actions">
        <button
          type="button"
          class="tp-support-image-preview__download"
          (click)="downloadSupportImagePreview($event)"
        >
          Download
        </button>
        <button
          type="button"
          class="tp-support-image-preview__close"
          (click)="closeSupportImagePreview($event)"
        >
          ×
        </button>
      </div>
    </div>
    <div class="tp-support-image-preview__body">
      <img
        *ngIf="supportImagePreviewType === 'image'; else supportVideoPreview"
        [src]="supportImagePreviewUrl"
        [alt]="supportImagePreviewName"
      />
      <ng-template #supportVideoPreview>
        <video
          controls
          playsinline
          preload="metadata"
          [src]="supportImagePreviewUrl"
        ></video>
      </ng-template>
    </div>
  </div>
</div>
